export default {
  'ei.png': 'ei.png',
  'giro.png': 'giro.png',
  'hometax.png': 'hometax.png',
  'popbill.png': 'popbill.png',
}
